<ng-template #titleArea>
@if (showMenuToggle) {
  <span fxShow [fxHide.gt-sm]="!showMenuDesktop">
    <button mat-button (click)="toggle()" class="sidenav-toggle" aria-label="Menu">
      <mat-icon>menu</mat-icon>
    </button>
  </span>
}

<a [routerLink]="homeUrl" fxLayout="row" fxLayoutAlign="center center" class="logo-focusable top-toolbar__brand">
  <img (click)=" refreshPage()" class="logo" src="assets/images/hero/logo.png" alt="Portal logo" />
  <span class="ag-hero-title top-toolbar__title">{{ titleKey | translate }}</span>
</a>
</ng-template>

<ng-template #userInfo>
  <button fxHide.xs mat-raised-button color="primary" (click)="logout()" class="field-height-button logout-btn">
    {{ 'logout' | translate }}
  </button>
  <button fxHide.gt-xs fxShow.xs mat-raised-button color="primary" (click)="logout()" class="field-height-button logout-btn">
    <mat-icon class="m-0">logout</mat-icon>
  </button>
</ng-template>

<mat-toolbar-row fxLayoutAlign="space-between center" class="ag-hero top-toolbar theme-container admin-toolbar">
  @if (showMenuDesktop && !isMobile) {
    <div fxLayout="row" fxLayoutAlign="center center">
      <ng-container *ngTemplateOutlet="titleArea"></ng-container>
    </div>
  } @else {
@if (showMenuToggle) {
  <span fxShow [fxHide.gt-sm]="!showMenuDesktop">
    <button mat-button (click)="toggle()" class="sidenav-toggle" aria-label="Menu">
      <mat-icon>menu</mat-icon>
    </button>
  </span>
}
<a [routerLink]="homeUrl" fxLayout="row" fxLayoutAlign="center center" class="logo-focusable top-toolbar__brand">
  <img (click)=" refreshPage()" class="logo" src="assets/images/hero/logo.png" alt="Portal logo" />
  <span class="ag-hero-title top-toolbar__title">{{ titleKey | translate }}</span>
</a>
}

@if (showMenuDesktop && !isMobile) {
  <div fxLayout="row" fxLayoutAlign="end center">
    <ng-container *ngTemplateOutlet="userInfo"></ng-container>
  </div>
} @else {
  <button fxHide.xs mat-raised-button color="primary" (click)="logout()" class="field-height-button logout-btn">
    {{ 'logout' | translate }}
  </button>
  <button fxHide.gt-xs fxShow.xs mat-raised-button color="primary" (click)="logout()" class="field-height-button logout-btn">
    <mat-icon class="m-0">logout</mat-icon>
  </button>
}
</mat-toolbar-row>
